module.exports = __webpack_public_path__ + "static/28-7c3596e6ad373a32139b3f5f995350f0.jpg";